export const pluginPermissions = {
  displayPlugin: [{
    action: 'plugin::course-editor.read',
    subject: null
  }],
  editDraft_publishedTab: [{
    action: 'plugin::course-editor.published-tab.edit-draft',
    subject: null
  }],
  editDraft_draftTab: [{
    action: 'plugin::course-editor.draft-tab.edit-draft',
    subject: null
  }],
  rejectDraft_draftTab: [{
    action: 'plugin::course-editor.draft-tab.reject-draft',
    subject: null
  }],
  save_draftView: [{
    action: 'plugin::course-editor.draft-view.save',
    subject: null
  }],
  requestApproval_draftView: [{
    action: 'plugin::course-editor.draft-view.request-approval',
    subject: null
  }],
  publish_draftView: [{
    action: 'plugin::course-editor.draft-view.publish',
    subject: null
  }],
  reject_draftView: [{
    action: 'plugin::course-editor.draft-view.reject',
    subject: null
  }],
  viewPublishedVersion_draftView: [{
    action: 'plugin::course-editor.draft-view.view-published-version',
    subject: null
  }],
  editAsDraft_publishedView: [{
    action: 'plugin::course-editor.published-view.edit-as-draft',
    subject: null
  }],
  rollbackVersion_publishedView: [{
    action: 'plugin::course-editor.published-view.rollback-version',
    subject: null
  }],
  readItems_learnosityView: [{
    action: 'plugin::course-editor.learnosity-view.read-items',
    subject: null
  }],
  editItems_learnosityView: [{
    action: 'plugin::course-editor.learnosity-view.edit-items',
    subject: null
  }],
  assignItems_learnosityView: [{
    action: 'plugin::course-editor.learnosity-view.assign-items',
    subject: null
  }],
  createItems_learnosityView: [{
    action: 'plugin::course-editor.learnosity-view.create-items',
    subject: null
  }],
  deleteTag_learnosityView: [{
    action: 'plugin::course-editor.learnosity-view.delete-tag',
    subject: null
  }],
  assignExistingTag_learnosityView: [{
    action: 'plugin::course-editor.learnosity-view.assign-existing-tag',
    subject: null
  }],
  createNewTag_learnosityView: [{
    action: 'plugin::course-editor.learnosity-view.create-new-tag',
    subject: null
  }],
  deleteExamTopic_learnosityView: [{
    action: 'plugin::course-editor.learnosity-view.delete-exam-topic',
    subject: null
  }],
  assignExistingExamTopic_learnosityView: [{
    action: 'plugin::course-editor.learnosity-view.assign-existing-exam-topic',
    subject: null
  }],
  createNewExamTopic_learnosityView: [{
    action: 'plugin::course-editor.learnosity-view.create-new-exam-topic',
    subject: null
  }],
  view_resourceSection: [{
    action: 'plugin::course-editor.resource-section.view',
    subject: null
  }]
};